module.exports = __webpack_public_path__ + "static/img/dongxi-bg.59118a0f.png";